<template>
    <section class="form-faq faqs-gradient pb-12 md:pb-4">
        <section class="flex justify-center items-center flex-col bg-viva-money-black">
        <div class="w-full md:w-3/5 px-8 md:px-0 md:max-w-screen-sm help-faqs-gradient pb-4 md:pb-4 mx-auto">
            <div class="help-accordion help-faq-accordion">
                <div class="help-faq-main-container pt-10">
                    <div v-for="(item, index) in questions" :key="index" class="help-faq-wrapper cursor-pointer">
                        <div :id="'help-faq-answer-' + item.id" class="help-faq-question-text float-left relative w-full block bg-white px-5 mb-5">
                            <p :id="'faq-' + item.id" class="help-faq-title question pr-8 pt-4 pb-6 help-question-border-bottom">
                                {{ item.title }}
                            </p>
                            <div class="help-faq-answer-text md:px-5">
                                {{ item.subtext }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </section>
</template>

<script>

export default {
    props: {
        questions: {
            type: Object,
            required: true
        }
    },
    mounted() {
        //toggle main accordion sections on apply form
        $(function() {
            $('.accordion-link').on('click', function(event) {
                if($(event.target).closest('.accordion-header').find('#accordion-toggle').hasClass('closed') == false){
                    window.amplitude.faqSectionToggle('open');
                }
                if($(event.target).closest('.accordion-header').find('#accordion-toggle').hasClass('closed') == true){
                    window.amplitude.faqSectionToggle('closed');
                }
                $(event.target).closest('.accordion-header').find('.accordion-status').toggleClass('closed');
                $(event.target).closest('.accordion-header').siblings().closest('.accordion').toggleClass('closed').slideToggle(250);
            });
        });

        //set the faq accordion default to be hidden
        $('.faq-accordion').hide();

        //faq dropdown functionality
        $(function() {
            $('.faq-question-text').on('click', function(event) {
            $('.faq-accordion').show();
            var faqWrapper = $(event.target).closest('.faq-wrapper');
            var faqAnswer = faqWrapper.find('.faq-answer-text');
            var faqText = $(this).find('.question').text().trim();

            //toggle the open close of the plus symbol
            $(this).toggleClass('rotate');
        
            // Close all other open FAQ sections and rotate the plus symbol
            $('.faq-answer-text.open').not(faqAnswer).slideUp(250).removeClass('open');
            $('.faq-question-text.rotate').not($(this)).removeClass('rotate');
            
            // Open/close the clicked FAQ section
            faqAnswer.slideToggle(250).toggleClass('open');
            if($(this).hasClass('rotate') == true) {
                window.amplitude.faqInteraction(faqText, 'open');
            }
            if($(this).hasClass('rotate') == false) {
                window.amplitude.faqInteraction(faqText, 'closed');
            }
            });
        });
    }
}
</script>

<style lang="scss" scoped>
.faq-accordion {
    .faq-question {
        cursor: pointer;
    }
    .faq-answer {
        display: none;
    }
    span {
        &.faq-accordion-plus {
            content: '';
            width: 31px;
            height: 31px;
            background-size: 31px 31px;
            background-image: url('/img/plus-sign.png');
            @media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
                background-image: url('/img/plus-sign@2x.png');
            }
            background-repeat: no-repeat;
            transform: rotateZ(0deg);
            transition: all 0.4s ease;
            &.faq-accordion-minus {
                background-image: url('/img/minus-sign.png');
                @media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {
                    background-image: url('/img/minus-sign@2x.png');
                }
            }
        }
    }
}

.form-faq {
    background: #FFFFFF;
}

.accordion-header {
    cursor: pointer;
    .accordion-link {
        text-decoration: none;
        display: flex;
        width: 100%;
        height: 56px;
        margin-bottom: 24px;
        justify-content: space-between;

        border-bottom: 1px solid #EAEAEA;
        p {
            font-size: 22px;
            font-weight: bold;
            display: flex;
            align-items: center;
            color: #4CB8C4;
        }
        .accordion-status {
            align-self: center;
            width: 16px;
            height: 10px;
            background-size: 16px 10px;
            background-image: url("/img/acc-up.svg");
            background-repeat: no-repeat;
            &.closed {
                background-image: url("/img/acc-down.svg");
            }
        }
    }
    .accordion-contact {
        border: none;
        margin-bottom: 0;
    }
}
.ll-blue {
    color:#4CB8C4;
}

.faq-question-text {
    color: #4CB8C4;
    border: 1px;
    border-style: solid;
    border-color: #4CB8C4;
    border-radius: 0 16px 16px 16px;
    &:after {
        position: absolute;
        background: no-repeat;
        background-image: url('/img/faq_plus.svg');
        background-size: 16px 16px;
        width: 16px;
        height: 16px;
        right: 20px;
        top: 20px;
        content: '';
        transition: transform 0.3s ease; /* add a transition effect for a smooth animation */
    }
}
.faq-question-text.rotate:after {
    transform: rotate(135deg);
  }
.faq-answer-text {
    width: 100%;
    float: left;
    position: relative;
    display: none;
    background: #FFFFFF;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    padding: 15px 0px 15px 0px ;
    &.open {
    }
}
.faqs-gradient {
    background: inherit;
    position: relative;
    overflow: hidden;
}
</style>